import { connect } from "react-redux";
import React, { useState } from "react";
import { Button, ModalHeader, ModalBody } from "reactstrap";
import { compose } from "redux";
import NavigationActions from "redux/navigation/actions";
import Loader from "components/Loader";
import * as Yup from "yup";
import { useFormik } from "formik";
import { addPatotsav, editPatotsav } from "services/patotsavServices";
import DatePickerWrapper from "components/common/DatePickerWrapper";
import DatePicker from "react-datepicker";

const { success, error } = NavigationActions;

const AddEditPatotsav = ({ isEdit, editData, onClose, token, toggleRefresh }) => {
  
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    gregorianDate: Yup.string()
        .required("Gregorian date is required.")
        .typeError("Gregorian date must be a valid date."),
    country: Yup.object().shape({
      english: Yup.string().required("Please enter the country name in English"),
      gujarati: Yup.string().required("Please enter the country name in Gujarati"),
      hindi: Yup.string().required("Please enter the country name in Hindi"),
    }),
    location: Yup.object().shape({
      english: Yup.string().required("Please enter the location name in English"),
      gujarati: Yup.string().required("Please enter the location name in Gujarati"),
      hindi: Yup.string().required("Please enter the location name in Hindi"),
    }),
    date: Yup.object().shape({
      english: Yup.string().required("Please enter the date in English"),
      gujarati: Yup.string().required("Please enter the date in Gujarati"),
      hindi: Yup.string().required("Please enter the date in Hindi"),
    }),
  });
  

  const formik = useFormik({
    initialValues: isEdit
      ? { ...editData, gregorianDate: editData?.gregorianDate ? new Date(editData?.gregorianDate) : new Date() }
      : {
          gregorianDate: new Date(),
          country: {
            english: "",
            gujarati: "",
            hindi: "",
          },
          location: {
            english: "",
            gujarati: "",
            hindi: "",
          },
          date: {
            english: "",
            gujarati: "",
            hindi: "",
          },
        },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        // console.log(values);
        const payload = {
          ...values,
          gregorianDate: values.gregorianDate.toISOString(),
        };

        const res = isEdit
          ? await editPatotsav(token, values?._id, payload)
          : await addPatotsav(token, payload);
        if (res?.success) {
          success(res?.message);
          onClose();
          toggleRefresh(true);
        } else {
          error(res?.message);
        }
      } catch (error) {
        error(error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    isValid,
    handleSubmit,
  } = formik;

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <>
      <ModalHeader toggle={() => onClose()}>
        {isEdit ? "Edit" : "Add"} Patotsav
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
        <div className="form-group">
            <label>
            Gregorian Date <span className="red">*</span>
            </label>
            <DatePickerWrapper>
              <DatePicker
                peekPriviousMonth
                showMonthDropdown
                showYearDropdown
                name="date"
                id="date"
                selected={values.gregorianDate}
                dateFormat="yyyy/MM/dd"
                className="form-control react-form-input"
                value={values.gregorianDate}
                onChange={(d) => {
                  formik.setFieldValue("gregorianDate", d);
                }}
                onBlur={handleBlur}
              />
            </DatePickerWrapper>
            <Error field="gregorianDate" />
          </div>
          <div className="form-group">
            <label>
              Country Name English<span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="country.english"
              onChange={handleChange}
              value={values.country.english}
              onBlur={handleBlur}
              placeholder="Country Name"
            />
            <Error field="country.english" />
          </div>

          <div className="form-group">
            <label>
              Country Name Gujarati<span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="country.gujarati"
              onChange={handleChange}
              value={values.country.gujarati}
              onBlur={handleBlur}
              placeholder="Country Name"
            />
            <Error field="country.gujarati" />
          </div>
          <div className="form-group">
            <label>
              Country Name Hindi<span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="country.hindi"
              onChange={handleChange}
              value={values.country.hindi}
              onBlur={handleBlur}
              placeholder="Country Name"
            />
            <Error field="country.hindi" />
          </div>
          
          <div className="form-group">
            <label>
              Patotsav Location English <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="location.english"
              onChange={handleChange}
              value={values.location.english}
              onBlur={handleBlur}
              placeholder="Patotsav location"
            />
            <Error field="location.english" />
          </div>
          <div className="form-group">
            <label>
              Patotsav Location Gujarati<span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="location.gujarati"
              onChange={handleChange}
              value={values.location.gujarati}
              onBlur={handleBlur}
              placeholder="Patotsav location"
            />
            <Error field="location.gujarati" />
          </div>
          <div className="form-group">
            <label>
              Patotsav Location Hindi<span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="location.hindi"
              onChange={handleChange}
              value={values.location.hindi}
              onBlur={handleBlur}
              placeholder="Patotsav location"
            />
            <Error field="location.hindi" />
          </div>
          <div className="form-group">
            <label>
              Patotsav Date Label English<span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="date.english"
              onChange={handleChange}
              value={values.date.english}
              onBlur={handleBlur}
              placeholder="Patotsav Date Label"
            />
            <Error field="date.english" />
          </div>

          <div className="form-group">
            <label>
              Patotsav Date Label Gujarati<span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="date.gujarati"
              onChange={handleChange}
              value={values.date.gujarati}
              onBlur={handleBlur}
              placeholder="Patotsav Date Label"
            />
            <Error field="date.gujarati" />
          </div>
          <div className="form-group">
            <label>
              Patotsav Date Label Hindi<span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="date.hindi"
              onChange={handleChange}
              value={values.date.hindi}
              onBlur={handleBlur}
              placeholder="Patotsav Date Label"
            />
            <Error field="date.hindi" />
          </div>
          <div className="row">
            <div className="col-5 offset-2 offset-sm-4 col-sm-4">
              <Button
                type="submit"
                className="btn form-button modaladdbutton"
                disabled={!isValid || loading}
              >
                {loading ? "Saving..." : "Save"}
              </Button>
            </div>
            <div className="col-5 col-sm-4">
              <Button
                onClick={onClose}
                className="btn form-button modalcancelbutton"
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </ModalBody>
      {loading ? <Loader /> : ""}
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};

export default compose(
  connect(mapStateToProps, { success, error })
)(AddEditPatotsav);
